import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { deleteRequest } from './requests/delete';
import { RequestData } from './types';

export const useApiDeleteRequest = <PathVariables, QueryParams, SuccessResponse, ErrorResponse = Error>(
  path: string,
  options?: Omit<
    UseMutationOptions<SuccessResponse, ErrorResponse, RequestData<PathVariables, QueryParams>>,
    'mutationFn'
  >,
) => {
  const controller = new AbortController();
  const { signal } = controller;

  const mutation = useMutation<SuccessResponse, ErrorResponse, RequestData<PathVariables, QueryParams, undefined>>({
    mutationFn: (params) => deleteRequest<SuccessResponse>(path, params?.pathVariables, params?.queryParams, signal),
    ...options,
  });

  const abort = () => {
    controller.abort();
    mutation.reset();
  };

  return {
    abort,
    ...mutation,
  };
};
